// WHAT OUTLOOK SAID, IN ONE WORD — the response vocabulary and its ink.
//
// Its home until 122: `EventPeopleOverview.tsx`, deleted in the same commit
// that created this file. It moved rather than died because the vocabulary is
// what two surfaces would otherwise duplicate, and the reasoning below is the
// reason the duplication would be a defect rather than a repetition.
//
// ── 119 §6 — GRAPH'S VOCABULARY, AND THE ONE WORD THAT IS OURS ──────────────
// `accepted` / `tentativelyAccepted` / `declined` are Outlook's answers and get
// Outlook's meaning. `organizer` is not an answer at all — it is the person who
// sent the invitation — so it renders as itself rather than as a reply.
//
// `none` AND ABSENT ARE THE SAME INK ON PURPOSE, and it is the honest one: on an
// event somebody ELSE organised, every attendee but the reader shows `none`
// whatever they actually answered (m365.js's `normalizeGraphAttendees` keeps
// that distinction rather than inventing certainty). "No answer yet" is the
// strongest thing that can truthfully be said about either.
import type { JSX } from "react";
import { useTranslation } from "../i18n";
import { FS } from "../lib/tokens";

const TONE: Record<string, string> = {
  accepted: "var(--gn)",
  tentativelyAccepted: "var(--am)",
  declined: "var(--rd)",
  organizer: "var(--ac)",
};
/* KEYS ONLY, no English beside them — `i18n-total` GATE 1's rule for text that
   reaches a human, and these five are seeded in en/fr/nl. An unseeded key
   renders as the bare key, which is a loud signal rather than a quiet English
   sentence in a French app. */
const WORD: Record<string, string> = {
  accepted: "people.response.accepted",
  tentativelyAccepted: "people.response.tentative",
  declined: "people.response.declined",
  organizer: "people.response.organizer",
};

/* 122 §2 — ONE COMPONENT, SO TWO SURFACES CANNOT DISAGREE about what
   `tentativelyAccepted` looks like. The status rides the ROW in the merged
   attendee list; a second copy of the maps above beside a checkbox is how the
   two come to drift. */
export default function ResponseChip({
  response,
}: {
  response?: string | null;
}): JSX.Element {
  const { t } = useTranslation();
  const key = (response && WORD[response]) || "people.response.none";
  return (
    <span
      style={{
        fontSize: FS.s9,
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: ".3px",
        color: (response && TONE[response]) || "var(--tm)",
        flexShrink: 0,
      }}
    >
      {t(key)}
    </span>
  );
}
